export default __webpack_public_path__ + "static/media/step-1-physical.e7764da2.jpg";